import type { RunProgress } from "@/lib/jobs-types";

/**
 * One run's progress as one line, shared by the Processing grid's Progress cell and the run-log panel
 * header (sc-114197). Counts are nullable end to end (a stage-only `Report(stage)` writes both null), so
 * the stage renders alone rather than behind a false "0":
 *
 * - no progress row → `—`
 * - `items_done` null (whatever `items_total` is) → `<stage>`
 * - `items_done` only → `<stage> · <done>`
 * - both → `<stage> · <done>/<total>`
 *
 * Counts render as plain `String(n)`, never locale-grouped; `0` is a value.
 */
export function formatProgress(progress: RunProgress | null): string {
  if (!progress) return "—";
  const { stage, items_done, items_total } = progress;
  if (items_done == null) return stage;
  if (items_total == null) return `${stage} · ${String(items_done)}`;
  return `${stage} · ${String(items_done)}/${String(items_total)}`;
}
